import { render, staticRenderFns } from "./UploadKYCDocs.vue?vue&type=template&id=86c09582&scoped=true"
import script from "./UploadKYCDocs.vue?vue&type=script&lang=js"
export * from "./UploadKYCDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c09582",
  null
  
)

export default component.exports